import { EMainProductCodeType } from '@aqx-core/common/api/config';
import { ISymbolTickRulesGroup } from '@aqx-core/common/api/market';
import { companyService } from '@aqx-core/common/services/company';

export const getDecimalFromPrice = (
  price: number | null | undefined,
  tickRulesGroup: ISymbolTickRulesGroup[] | undefined
): number => {
  if (price === undefined || price === null || !tickRulesGroup || tickRulesGroup.length === 0) {
    return 2;
  }
  // Find the appropriate tick rule based on the price
  const tickRule = [...tickRulesGroup]
    .sort((a, b) => b.startTickPriceRange - a.startTickPriceRange) // Sort in descending order of startTickPriceRange
    .find((tickRule) => price >= tickRule.startTickPriceRange);

  if (!tickRule || tickRule.tickIncrement === undefined) {
    return 2;
  }

  // if the tickIcrement is 1 , should return 0
  const decimal = tickRule.tickIncrement.toString().split('.')[1]?.length ?? 0;

  return decimal;
};

export const getDecimalForCompanyIntegration = (
  price: number | null | undefined,
  tickRulesGroup?: ISymbolTickRulesGroup[],
  symbolDecimal?: number,
  overrideCompanyIntegration?: EMainProductCodeType
): number => {
  const integration = overrideCompanyIntegration ?? companyService.getCompanyIntegration();

  if (integration === EMainProductCodeType.HORIZON) {
    return getDecimalFromPrice(price, tickRulesGroup);
  }

  return symbolDecimal ?? 2;
};
